import * as TypeEvaluation from '../TypeEvaluation';
import * as CoreFns from './CoreFns';
import * as HelperFunctions from './HelperFunctions';
import * as StyleFunctions from './StyleFunctions';
import * as ResponsiveFns from './ResponsiveFns';
import * as SharedAcross from './SharedAcross';

/* global BigInt */
export function getDateFromSql(input){
  var date = currentDateFromSql(input);
  var todayMidnight = new Date();
  todayMidnight.setHours(0);
  todayMidnight.setMinutes(0);
  todayMidnight.setSeconds(0);
  var timeDiff = date.getTime() - todayMidnight.getTime();
  var dS = date.toString();
  if (timeDiff > 0){
    return 'Today at ' + dS.substr(16, 8);
  }else if (timeDiff > -86400000){
    return 'Yesterday at ' + dS.substr(16, 8);
  }
  return dS.substr(4, 11);
}

export function getDateTimeFromSql(input){
  var date = currentDateFromSql(input);
  return date.toString().split(' GMT')[0];
}


export function currentDateFromSql(input){
  var dateTimeSet = input.v[1].v;
  var dateSet = dateTimeSet[0].v;
  var timeSet = dateTimeSet[1].v;

  return new Date(Date.UTC(dateSet[0].v, dateSet[1].v - 1, dateSet[2].v, timeSet[0].v, timeSet[1].v, timeSet[2].v));
}

export function isDeploymentAlive(timeStampSql){
  var timeStamp = currentDateFromSql(timeStampSql);
  var timeStampInt = timeStamp.getTime();
  var currentDate = new Date();
  var currentDateInt = currentDate.getTime();
  return (timeStampInt > currentDateInt);
}


export function getDefaultValues(type){
  if (type.t === 'UInteger' || type.t === 'Integer'){
    return BigInt(0);
  }else if (type.t === 'Decimal'){
    return 0;
  }else if (type.t === 'Address'){
    return '0x0000000000000000000000000000000000000000';
  }else if (type.t === 'Transaction'){
    return '0x00000000000000000000000000000000000000000000000000000000000000000000000000000000';
  }else if (type.t === 'Text String' ){
    return '-';
  }else if (type.t === 'ListType'){
    return [];
  }else if (type.t === 'Boolean' || type.t === 'any'){
    return false;
  }else if (type.t === 'Object'){
    var p = {};
    type.c.forEach((aC, index)=>{
      var cc = getDefaultValues(aC.t);
      p[aC.key] = cc;
    })
    return p;
  }else{
    console.warn(type);
  }
}

function textToInt(text){
  if (!text){
    text = '0';
  }
  return BigInt(text);
}

export function getNativeBalance(currentList, internalVariables, userAddress){

  if (StyleFunctions.isCorrectChain(currentList, internalVariables)){
      
    var chainInfo = internalVariables.chainInfo;
    var setChainInfo = internalVariables.setChainInfo;

    if (!chainInfo.nativeBalance){
      chainInfo.nativeBalance = {};
      setChainInfo({...chainInfo});
    }    

    var nativeBalance = chainInfo.nativeBalance;
    if (nativeBalance[userAddress]){
      return nativeBalance[userAddress];
    }
    nativeBalance[userAddress] = {k:BigInt('0')};
    setChainInfo({...chainInfo});

  }
  return {k:BigInt(0)};
}



export function bigIntMax(args){
  var firstItem = args[0];
  for (var i = 1; i < args.length; i++){
    if (args[i] > ( firstItem )){
      firstItem = args[i];
    } 
  }
  return firstItem;
}
export function bigIntMin(args){
  var firstItem = args[0];
  for (var i = 1; i < args.length; i++){
    if (args[i] < ( firstItem )){
      firstItem = args[i];
    } 
  }
  return firstItem;
}

export function indexInAList(val, list){
  for (var i = 0; i < list.length; i++){
    if (list[i] === val){
      return i;
    }
  }
  return -1;
}


export function coverWithAppropriateDecimals(number, nosDecimals){
  var start = BigInt('10');
  var decimalLocation = start ** nosDecimals;
  var inte = number / (decimalLocation);
  var deci = number % decimalLocation;
  var deciString = deci.toString();
  if (deciString === '0'){
    return inte.toString();
  }
  var pad = '';
  for (var i = deciString.length; i < Number(nosDecimals); i++){
    pad += '0';
  }
  return inte.toString() + '.' + pad + deciString;
}



export function checkEquality(left, right, type){
  if (type.t === 'ListType'){
    if (left.length === right.length){
      for (var i = 0; i < left.length; i++){
        var p = checkEquality(left[i], right[i], type.c);
        if (!p){
          return false;
        }
      }
      return true;
    }else{
      return false;
    }
  }else if (type.t === 'Object'){
    for (var i1 = 0; i1 < type.c.length; i1++){
      var title = type.c[i1].key;
      var p1 = checkEquality(left[title], right[title], type.c[i1].t);
      if (!p1){
        return false;
      }
    }
    return true;
  }else if (type.t === 'Date' || type.t === 'Date Time'){
    return left.getTime() === right.getTime();
  }else{
    return left === right;
  }
}

export function evaluateCondition(infoSet, type, entityPath, currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains){
  if (infoSet && infoSet.t === 'formula'){
    try{
      var condition = infoSet.o;
      return actEvaluateCondition(condition, entityPath, currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);      
    }catch(err){
      console.log(err);
      console.log(err);
      return getDefaultValues(type);
    }
  }else if (type.t === 'UInteger' || type.t === 'Integer'){
    return BigInt(infoSet);
  }else if (type.t === 'Boolean'){
    if (infoSet){
      return true;
    }else{
      return false;
    }
  }else if (type.t === 'ListType'){
    var sPieces = infoSet.s;
    var sKeys = CoreFns.sortedKeyList(sPieces);
    return sKeys.map((aK, index)=>{
      return evaluateCondition(sPieces[aK].v, type.c, entityPath.concat(['s', aK, 'v']), currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, chains);
    })
  }else if (type.t === 'Object'){
    var outStruct = {};

    type.c.forEach((aSub, index)=>{
      var here = evaluateCondition(infoSet[aSub.keyOnce], aSub.t, entityPath.concat([aSub.keyOnce]), currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
      outStruct[aSub.n] = here;
    })
    return outStruct;

  }else if (type.t === 'Object'){
    var outObject = {};
    if (infoSet){
      type.c.forEach((aC, index)=>{
        var point = aC.key;
        var here = evaluateCondition(infoSet[point], aC.t, entityPath.concat([point]), currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
        outObject[point] = here;

      })      
    }
    return outObject;
  }else{
    return infoSet;
  }
}


function flattenType(inputType, aI){
  if (inputType.t === 'UInteger'){
    return aI.toString();
  }else if (inputType.t === 'Address' || inputType.t === 'Text String' || inputType.t === 'Transaction'){
    if (!aI){
      return 'emptyString';
    }
    return aI;
  }else if (inputType.t === 'ListType'){
    return aI.map((aFlat, index)=>{
      return flattenType(inputType.c, aFlat);
    }).join(', ');
  }else if (inputType.t === 'any'){
    return '_';
  }else if (inputType.t === 'Object'){
    var cc = {};
    inputType.c.forEach((aInput, index)=>{
      var p = flattenType(aInput, aI[aInput.ti]);
      cc[aInput.ti] = p;
    })
    return JSON.stringify(cc);
  }else{
    console.warn(inputType);
    console.warn(aI);
  }
  return 'a';
}

function layoutFoundationForAnObject(list, chainInfo){
  var p = chainInfo;
  for (var i = 0; i < list.length; i++){
    var p1 = p[list[i]];
    if (!p1){
      p[list[i]] = {};
      p1 = p[list[i]];
    }
    p = p1;
  }
  return p;
}


function formatNumberTextWithComma(text){
  return text.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

function getValueFromExistingSmartContract(eS, inputProcessedIn, internalVariables, chains, currentList){

  var defaultSlate = {};
  var abi = ResponsiveFns.getToRelevantAbi(eS, currentList);
  if (abi){

    var chainInfo = internalVariables.chainInfo;

    if (internalVariables.activeUser){

      var inputProcessed = inputProcessedIn.filter((aI, index)=>{
        return index < abi.inputs.length;
      })

      var flattenedInputs = inputProcessed.map((aI, index)=>{
        var thisInput = abi.inputs[+index];
        var inputType = TypeEvaluation.convertSCTypeToInternalType(thisInput);
        return flattenType(inputType, aI);
      })

      var point = [eS.s, eS.i].concat(flattenedInputs);
      var pOut = layoutFoundationForAnObject(point, chainInfo);
      // console.log(chainInfo);
      var namePointer = '_';
      if (abi.outputs.length > 1){
        namePointer = '_' + eS.n;
      }
      if (pOut[namePointer] !== undefined){
        if (pOut[namePointer] && pOut[namePointer]['xXXxxxxXXXX123xxxx']){
          return defaultSlate;
        }
        return pOut;
      }else{

        var abi1 = CoreFns.getContractInfoAbi(currentList, eS.s);
        var address = ResponsiveFns.getContractAddr(currentList, eS.s);

        var stuff = {
          address: address,
          abi: abi1,
          functionName: eS.i.split(' ')[0],
          args: inputProcessed
        };
        pOut[namePointer] = {'xXXxxxxXXXX123xxxx':stuff, origAbi:abi, point}
        var setChainInfo = internalVariables.setChainInfo;
        setChainInfo({...chainInfo})


      }
    }    
  }
  return defaultSlate;
}

function actEvaluateCondition(condition, entityPath, currentList, internalVariables, width, height, upwardInfoIn, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains){


    function evaluateC(condition, upwardInfo){

      function getAppendText(orig, condition){
        for (var i15 = 0; i15 < condition.p.length; i15++){
          var aCond = condition.p[i15];
          if (aCond.t === 'oP'){
            orig = orig[aCond.n];
          }else{
            var calc = evaluateC(aCond, upwardInfo);
            orig = orig[calc];
          }
        }
        return orig;      
      }

      var ct = condition.t;

      if (ct === 's' || ct === 'ad' || ct === 'scr' || ct === 'mus' || ct === 'coin' || ct === 'curr' || ct === 'pu'){
        return condition.v;
      }else if (ct === 'ca'){
        var smartContracts = currentList.sc;
        var thisSc = smartContracts[condition.v];
        if (thisSc){
          var addSet = thisSc.addSet;
          var addSetKeys = Object.keys(addSet);
          return addSet[addSetKeys[0]].addr;
        }
        return '';
      }else if (ct === 'dt'){
        return BigInt(condition.v);
      }else if (ct === 'ui' || ct === 'i'){
        var vv = condition.v;
        if (vv.substr(0,1) === '+'){
          vv = vv.substr(1);
        }
        return BigInt(vv);
      }else if (ct === 'dc'){
        return +condition.v;
      }else if (ct === 'footer'){
        return ['fo'];
      }else if (ct === 'gi'){
        return HelperFunctions.findItemFromUpwardInfo('gI_'+condition.v, upwardInfo);
      }else if (ct === 'eS'){
        var l1 = condition.v.map((aP, index)=>{
          return evaluateC(aP, upwardInfo);
        })


        var xOrig1 = getValueFromExistingSmartContract(condition, l1, internalVariables, chains, currentList);
        var requireChecked1 = HelperFunctions.findItemFromUpwardInfo('RequireChecked', upwardInfo);
        if (requireChecked1){
          if (!xOrig1.checked){
            throw new Error('not yet checked');
          }
        }
        var abi1 = ResponsiveFns.getToRelevantAbi(condition, currentList);
        if (abi1){
          var thisOutput1 = TypeEvaluation.getOutputFromESOutputs(abi1, condition.n);
          var namePointer = '_';
          if (abi1.outputs.length > 1){
            namePointer =  '_' + condition.n;
          }
          if (xOrig1.checked){
            var x1 = xOrig1[namePointer];
            return getAppendText(x1, condition); 
          }else{

              for (var i711 = 0; i711 < condition.a.length; i711++){
                thisOutput1 = thisOutput1.components1[condition.a[i711]];
              }
              var outputType1 = TypeEvaluation.walkDownObjPathToGetType(TypeEvaluation.convertSCTypeToInternalType(thisOutput1), condition.p);
              return getDefaultValues(outputType1);
          }

        }else{
          return 'something';
        }          

      }else if (ct === 'eV'){

        var l11 = condition.v.map((aP, index)=>{
          return evaluateC(aP, upwardInfo);
        })
        var abi2 = ResponsiveFns.getToRelevantAbi(condition, currentList);
        var nosIndexed = 0;
        if (abi2){
          var conditions = abi2.inputs.map((anInput, index)=>{
            if (anInput.indexed){
              nosIndexed ++;
              return l11[nosIndexed - 1];
            }else{
              return null;
            }
          })
          return {name:abi2.name, conditions};          
        }else{
          return null;
        }
      }else if (ct === 'pl'){
        if (condition.ti === 'Text String' || condition.ti === 'Address' || condition.ti === 'Transaction'){
          return condition.v;
        }else if (condition.ti === 'Decimal'){
          return +condition.v;
        }else if (condition.ti === 'UInteger' || condition.ti === 'Integer'){
          return BigInt(condition.v);
        }
      }else if (ct === 'oVar'){
        var oVal = 0;
        if (ownVariables[condition.v] !== undefined){
          oVal = ownVariables[condition.v];
        }
        return getAppendText(oVal, condition);
      }else if (ct === 'aC'){
        return getAppendText(HelperFunctions.findItemFromUpwardInfo(condition.v.s + '_' + condition.v.k, upwardInfo), condition);
      }else if (ct === 'gV'){
        return getAppendText(HelperFunctions.findItemFromUpwardInfoNew('gV', condition.v, upwardInfo), condition);
      }else if (ct === 'pa' || ct === 'al'){
        return condition.v.join('_');
      }else if (ct === 'm'){
        var x5 = HelperFunctions.findItemFromUpwardInfo(condition.v, upwardInfo);
        return getAppendText(x5, condition);
      }else if (ct === 'inP' ){
        if (inputValues){
          var cond = condition.v.join(' ') + '_';
          var toGo = inputValues[cond];
          if (toGo){
            var val = toGo.value;
              var inputType = toGo.inputType;
              if (inputType === 'Integer' || inputType === 'UInteger'){
                if (val === '' || val === '-' || val === '.'){
                  return BigInt(0);
                }else{
                  return BigInt(val);
                }
              }else if (inputType === 'Decimal'){
                if (val === '' || val === '-' || val === '.'){
                  val = 0;
                }else{
                  val = +val;
                }
                return val;
              }else if (inputType === 'Date' || inputType === 'Date Time'){
                return new Date(val);
              }else if (inputType === 'Text String' || inputType === 'Single Select' || inputType === 'Radio'){
                return val;
              }else{
                console.warn(toGo);
                console.warn(inputType);
              }
            
          }else{
            var item;
            try{
              item = CoreFns.goDownPath(currentList, condition.v);
            }catch(err){
              console.log(err);
            }
            if (item){
              var currentInputType = item.s.inputType.v;
              var allowMultiple = false;
              if (currentInputType === 'Radio'){
                allowMultiple = item.s.allowMultiple;
              }
              var relevant = StyleFunctions.getRelevantValueTgt(currentInputType, allowMultiple);
              if (item.s[relevant].t === 'formula'){
                return evaluateC(item.s[relevant].o, upwardInfo);
              }else{
                var x = item.s[relevant].v;
                if (relevant === 'valueUInteger' || relevant === 'valueInteger'){
                  return BigInt(x);
                }else if (relevant === 'valueDecimal'){
                  return +x;
                }else if (relevant === 'valueListString'){
                  return [];
                }else{
                  return x;
                }
              }
            }
          }
        }
        throw new Error('X1');
      }else if (ct === 'f'){ 
        var i = condition.i;
        if (i === 24){
          var upwardInfotype4 = TypeEvaluation.evalType(condition.v[0], entityPath, currentList);
          var l3 = evaluateC(condition.v[0], upwardInfo);
          return l3.sort(function(_mapVarLeft, _mapVarRight){
            if (evaluateC(condition.v[1], upwardInfo.concat([{t:condition.m0, type:upwardInfotype4.c, v:_mapVarLeft},{t:condition.m1, type:upwardInfotype4.c, v:_mapVarRight}]))){
              return -1;
            }else{
              return 1;
            }
          });
        }else if (i === 58){  
          var upwardInfotype = TypeEvaluation.evalType(condition.v[0], entityPath, currentList, upwardInfo);
          var l0 = evaluateC(condition.v[0], upwardInfo);
          return l0.map((_mapVar, index)=>{
            return evaluateC(condition.v[1], upwardInfo.concat([{t:condition.m0, type:upwardInfotype.c, v:_mapVar}]));
          });
        }else if (i === 59){
          var upwardInfotype1 = TypeEvaluation.evalType(condition.v[0], entityPath, currentList);
          var l2 = evaluateC(condition.v[0], upwardInfo);
          return l2.filter((_mapVar, index)=>{
            return evaluateC(condition.v[1], upwardInfo.concat([{t:condition.m0, type:upwardInfotype1.c, v:_mapVar}]));});
        }else if (i === 71){
          var upwardInfotype2 = TypeEvaluation.evalType(condition.v[0], entityPath, currentList, upwardInfo);
          var upwardInfotype3 = TypeEvaluation.evalType(condition.v[1], entityPath, currentList, upwardInfo);
          var t0 = evaluateC(condition.v[0], upwardInfo);
          var t1 = evaluateC(condition.v[1], upwardInfo);
          return t0.reduce((_mapVarStart,_mapVarList, index)=>{
            return evaluateC(condition.v[2], upwardInfo.concat([{t:condition.m0, type:upwardInfotype2.c, v:_mapVarList},{t:condition.m1, type:upwardInfotype3, v:_mapVarStart}]));
          }, t1);
        }else{
          var l = condition.v.map((aP, index)=>{
            return evaluateC(aP, upwardInfo);
          })
          var typeOfFirstVar;
          if (condition.v.length > 0){
            typeOfFirstVar = TypeEvaluation.evalType(condition.v[0], entityPath, currentList, upwardInfo); 
          }


          if (i === 0){ //integer_to_string
            var xx = l[0].toString();
            if (l[1]){
              return formatNumberTextWithComma(xx)
            }else{
              return xx;
            }
          }else if (i === 1){ //absolute
            if (typeOfFirstVar.t === 'Integer' || typeOfFirstVar.t === 'UInteger'){
              return l[0].abs();
            }else{
              return Math.abs(l[0]);
            }
          }else if (i === 2 || i === 3 || i === 4 || i === 5 || i === 135){ //sum
            if (typeOfFirstVar.t === 'Integer' || typeOfFirstVar.t === 'UInteger'){
              if (i === 2){ 
                return l.reduce((startPt, aPt)=>{return startPt + (aPt)}, BigInt(0));
              }else if (i === 3){ 
                return l[0] - l[1];
              }else if (i === 4){ 
                return l.reduce((startPt, aPt)=>{return startPt * (aPt)}, BigInt(1));
              }else if (i === 5){ 
                return l[0] / l[1];
              }else if (i === 135){ 
                return l[0] ** l[1];
              }
            }else{
              if (i === 2){
                return l.reduce((startPt, aPt)=>{return startPt + aPt}, 0);
              }else if (i === 3){
                return l[0] - l[1];
              }else if (i === 4){ 
                return l.reduce((startPt, aPt)=>{return startPt * aPt}, 1);
              }else if (i === 5){
                return l[0] / l[1];
              }
            }
          }else if (i === 6){ //max
            if (typeOfFirstVar.t === 'Integer' || typeOfFirstVar.t === 'UInteger'){
              return bigIntMax(l);
            }else{
              return Math.max(l);
            }
          }else if (i === 7){ //min
            if (typeOfFirstVar.t === 'Integer' || typeOfFirstVar.t === 'UInteger'){
              return bigIntMin(l);
            }else{
              return Math.min(l);
            }
          }else if (i === 8){ return true;
          }else if (i === 9){ return false;
          }else if (i === 10){ //not
            return !l[0];
          }else if (i === 11){ //and
            return l.reduce((startPt, aPt)=>{return startPt && aPt}, true);
          }else if (i === 12){ //or
            return l.reduce((startPt, aPt)=>{return startPt || aPt}, false);
          }else if (i === 13){ //"IF_THEN_ELSE"
            return l[0] ? l[1] : l[2];
          }else if (i === 14){
            return checkEquality(l[0], l[1], typeOfFirstVar);
          }else if (i === 15){ 
            if (typeOfFirstVar.t === 'Integer' || typeOfFirstVar.t === 'UInteger'){ return l[0] >= (l[1]);
            }else{ return l[0] >= l[1]};
          }else if (i === 16){ 
            if (typeOfFirstVar.t === 'Integer' || typeOfFirstVar.t === 'UInteger'){ return l[0] > (l[1]);
            }else{ return l[0] > l[1]}
          }else if (i === 17){ 
            if (typeOfFirstVar.t === 'Integer' || typeOfFirstVar.t === 'UInteger'){ return l[0] <= (l[1]);
            }else{ return l[0] <= l[1];}
          }else if (i === 18){ 
            return l[0] < l[1];
          }else if (i === 19){
            return BigInt(Math.round(width));
          }else if (i === 20){ 
            return BigInt(Math.round(height));
          }else if (i === 21){
            try{
              if (l[0] <= (l[1])){
                var init = Number(l[0]);
                var ender = Number(l[1]);
                var out = [];
                for (var i10 = init; i10 <= ender; i10++ ){
                  out.push(BigInt(i10));
                }
                return out;
              }
            }catch(err){
            }
            return [];
          }else if (i === 22){
            return doOtherInfo(internalVariables, 'image_' + l[0], l[0], 'singularTextFromObject', 'image', '');
          }else if (i === 23){
            return doOtherInfo(internalVariables, 'name_' + l[0], l[0], 'singularTextFromObject', 'name', '');
          }else if (i === 25){ 
            return l[0] < l[1];
          }else if (i === 26){
            return urlHeader;
            // return window.location.href.split('?')[0];
          }else if (i === 27){ return "rgb("+Number(l[0])+"," + Number(l[1])+","+ Number(l[2])+")";
          }else if (i === 28){ return "red";
          }else if (i === 29){ return "green";
          }else if (i === 30){ return "blue";
          }else if (i === 31){ return "yellow";
          }else if (i === 32){ return "white";
          }else if (i === 33){ return "black";
          }else if (i === 37){ return "visible";
          // }else if (i === 38){ return "\"invisible\"";
          }else if (i === 39){ return "hidden";
          }else if (i === 41){ 
            if (internalVariables.dateTime){ 
              return BigInt(Math.floor(internalVariables.dateTime/1000));
            }
            return BigInt(Math.floor(new Date()/1000));
          }else if (i === 42){ return '';
          // }else if (i === 42){ return (function(){var d = new Date(); d.setHours(0,0,0,0); return d})();
          }else if (i === 43){ return BigInt(Math.floor(new Date()/1000));
          }else if (i === 44){ return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(l[0]));
          }else if (i === 45){ return l[0] / l[1];
          }else if (i === 46){ return StyleFunctions.dispDateOrDateTime(Number(l[0]), l[1], l[2], l[3]);
          }else if (i === 47){ 
            var upwardInfoType4 = TypeEvaluation.evalType(condition.v[0], entityPath, currentList, upwardInfo);
            if (upwardInfoType4.t === 'UInteger'){
              for (var i6 = 0; i6 < l[1].length; i6++){
                var ppp = checkEquality(l[0], l[1][i6], upwardInfoType4);
                if (ppp){
                  return true;
                }
              }
              return false;
            }else{
              return l[1].includes(l[0]);
            }
          }else if (i === 48){ return indexInAList(l[0],l[1]);
          }else if (i === 49){
            return doOtherInfo(internalVariables, 'description_' + l[0], l[0], 'singularTextFromObject', 'description', '');
          }else if (i === 50){
            return doOtherInfo(internalVariables, l[1] + '_' + l[0], l[0], 'singularTextFromObject', l[1], '');
          }else if (i === 51){ return l[0].join(l[1]);
          }else if (i === 52){ return l[1].filter((x, index)=>{return (+index < l[0])});
          }else if (i === 53){ return BigInt(l[0].length);
          }else if (i === 54){ return l.join("");
          }else if (i === 55){ return (function(d0){var d = Number(d0) * 1000; var d1 = new Date(d.getTime()); d1.setHours(Number(l[1]), Number(l[2]), Number(l[3]),0); return BigInt(Math.floor(d1/1000))})(l[0]);
          }else if (i === 56){ return l[1] + (l[0]);
          }else if (i === 57){ return l[0].indexOf(l[1] > -1);
          }else if (i === 60){ return l;
          }else if (i === 61){
            var outX = {};
            condition.v.forEach((aPiece, index)=>{
              outX[aPiece.ti] = l[index];
            });
            return outX;
          }else if (i === 62){ return l[0] + 'em';
          }else if (i === 63){ return l[0] + 'px';
          }else if (i === 65){ return BigInt('0'); //temp;
          }else if (i === 66){ return l;
          }else if (i === 67){ return null;
          }else if (i === 68){ return l[0];
          }else if (i === 69){ return 'begin';
          }else if (i === 70){ return 'middle';
          }else if (i === 72){ return 'end';
          }else if (i === 73){ 
            return l[1].filter((value)=>{return value === l[0];}).length;
          }else if (i === 74){ return 'top';
          }else if (i === 75){ return 'middle';
          }else if (i === 76){ return 'bottom';
          }else if (i === 77){
            return l[0].filter((value, index, self)=>{return self.indexOf(value) === index;});
          }else if (i === 78){ 
            if (!l[0]){
              return 0;
            }else{
              return Number(l[0]) ;
            }
          }else if (i === 79){
            const urlParams = new URLSearchParams(urlParamsForExecution);
            return urlParams.get(l[0]);
          }else if (i === 80){ return l[0] % l[1];
          }else if (i === 81){ return l[0] % l[1];
          }else if (i === 82){ return (new Date(Number(l[0]) * 1000)).getHours();
          }else if (i === 83){ return (new Date(Number(l[0]) * 1000)).getMinutes();
          }else if (i === 84){ return (new Date(Number(l[0]) * 1000)).getSeconds();
          }else if (i === 85){ return Math.sqrt(l[0]);

          }else if (i === 88){ return StyleFunctions.shortenName(l[0], l[1], l[2]);
          }else if (i === 93){ return Number(l[0][l[1]]);
          }else if (i === 95){ 
            var bal = getNativeBalance(currentList, internalVariables, l[0]);
            if (HelperFunctions.findItemFromUpwardInfo('RequireChecked', upwardInfo)){
              if (!bal.checked){
                throw new Error('not yet checked');
              }
            }
            return bal.k;

          }else if (i === 97){
             return textToInt(l[0]);
          }else if (i === 98){ return textToInt(l[0]);
          }else if (i === 99){ return l[0].reduce((startPt, aPt)=>{return startPt + aPt;}, 0)
          }else if (i === 100){ return l[0].reduce((startPt, aPt)=>{return startPt * aPt;}, 1)
          }else if (i === 101){ return Math.max(...l[0]);
          }else if (i === 102){ return Math.min(...l[0]);

          }else if (i === 103){
            var coin = l[0];
            var currency = l[1];
            var reference = 'price_' + coin + '_' + currency;
            var url = 'https://api.coingecko.com/api/v3/simple/price?ids='+coin+'&vs_currencies='+currency+'&include_market_cap=false&include_24hr_vol=false&include_24hr_change=false&include_last_updated_at=false';
            return doOtherInfo(internalVariables, reference, url, 'singularDecimal', coin, currency);
          }else if (i === 104){
            var coin1 = l[0];
            var currency1 = l[1];
            var days = l[2].toString();
            var reference1 = 'priceRange_' + coin1 + '_' + currency1 + '_' + days;
            var interval = 'daily';
            if (+days <= 2){
              interval = 'hourly';
            }
            var url1 = 'https://api.coingecko.com/api/v3/coins/'+coin1+'/market_chart?vs_currency='+currency1+'&days='+days+'&interval=' + interval;
            return doOtherInfo(internalVariables, reference1, url1, 'listDateDecimal', 'prices', coin1 + ' ' + currency1);
          }else if (i === 105){
            return SharedAcross.isEthAddress(l[0]);
          }else if (i === 106){
            return BigInt(HelperFunctions.pickUpInternalVariable(internalVariables, 'chainId'));
          }else if (i === 107){
            return BigInt(CoreFns.relevantChainId(currentList));
          }else if (i === 108){
            return StyleFunctions.correctChainName(currentList, chains);
          }else if (i === 112){ return l[0];
          }else if (i === 113){ 
            return HelperFunctions.pickUpInternalVariable(internalVariables, 'isConnected');
          }else if (i === 114){
            if (internalVariables.currentScreen && internalVariables.currentScreen.t === 'fe'){
              return internalVariables.currentScreen.v;
            }
            return false;
          }else if (i === 117){ 
            return HelperFunctions.pickUpInternalVariable(internalVariables, 'activeUser');
          }else if (i === 118){
            return (new Date(Date.UTC(l[0],l[1] - 1,l[2],l[3],l[4],l[5])));
          }else if (i === 119){ return l[0].lt(l[1]);
          }else if (i === 122){ 
            if (l[0] !== undefined){
              var xy = l[0].toString();
              if (l[1]){
                return formatNumberTextWithComma(xy)
              }else{
                return xy;
              }
            }else{
              return '';
            }
          }else if (i === 123){
            return doOtherInfo(internalVariables, 'video_' + l[0], l[0], 'singularTextFromObject', 'video', '');
          }else if (i === 124){ return 'YYYY_MM_DD';
          }else if (i === 125){ return 'DD_MM_YYYY';
          }else if (i === 126){ return 'MM_DD_YYYY';
          }else if (i === 127){ return false;
          }else if (i === 129){
            var lx = l[0];
            if (!lx){
              lx = BigInt('0');
            }
           return lx.abs();
          }else if (i === 130){ 
            var zeros = BigInt(0);
            var e1 = checkEquality(l[1], zeros, typeOfFirstVar);
            if (e1){
              return zeros;
            }else{
              return l[0].div(l[1]);
            }
          }else if (i === 131){ return l[0];
          }else if (i === 132){ return coverWithAppropriateDecimals(l[0], l[1]);
          }else if (i === 133){ return StyleFunctions.makeADecimalTextIntoBigNum(l[0].toString(), Number(l[1]));
          }else if (i === 134){ return parseFloat(l[0]);
          }else if (i === 135){ 
            return l[0] * (l[1]);
          }else if (i === 136){ return Math.pow(l[0], l[1]);
          }else if (i === 137){ 
            var txt = 'https://route-api.dodoex.io/dodoapi/getdodoroute?fromTokenAddress=' + l[0] + '&fromTokenDecimals=' + Number(l[1]) + '&toTokenAddress=' + l[2] + '&toTokenDecimals=' + Number(l[3]) + '&fromAmount=1&slippage=1&userAddr=0x9f456D1633Df3DF0D65a7c0c553b2186151B622F&chainId=' + CoreFns.relevantChainId(currentList);
            return doOtherInfo(internalVariables, txt, txt, 'dodo', '', '');
          }else if (i === 138){
            if (l[1] > (l[2])){
              var a1 = 10 ** Number(l[2]);
              var a2 = BigInt('10') ** (l[1] - l[2]);
              return Number((l[0] / a2))/(a1);
            }else{
              return Number(l[0] / (BigInt(10) ** l[1]));
            }
          }else if (i === 139){
            var nosD = Number(l[1]);
            if (nosD > 100){
              nosD = 100;
            }
            var pp5 = Number(l[0]).toFixed(nosD);
            if (l[2]){
              return (+pp5).toLocaleString("en-US");
            }else{
              return pp5;
            }
          }else if (i === 140){
            return l[0];

          }else{
              console.warn(condition);
          }
        }

      }else{
        console.warn(condition);
      }
    }
    return evaluateC(condition, upwardInfoIn);

  }

//check against other standard fns
function doOtherInfo(internalVariables, reference, url, type, a, b){
  if (url === '_' || url === '-'){
    if (type === 'singularDecimal' || type === 'dodo'){
     return 0;      
    }else if (type === 'listDateDecimal'){
      return [];
    }else if (type === 'singularTextFromObject'){
      return '';
    }
  }


    var otherInfo = internalVariables.otherInfo;
    var setOtherInfo = internalVariables.setOtherInfo;
    if (setOtherInfo){
      if (otherInfo[reference]){
        if (otherInfo[reference].loaded){
          return otherInfo[reference].v;
        }
      }else{
        url = url.split('infura.').join('');

        if (url.indexOf('ipfs://') === 0){
          url = 'https://ipfs.io/ipfs/' + url.substr(7);

          // url = 'https://bushicro.mypinata.cloud/ipfs/' + url.substr(7) + '?pinataGatewayToken=G8NWjBrx_74Dy55cv3YnnTofKhpbqezpLFib6svdXZYiACRcjyBawGgJuDgtoYaZ';

        }

        fetch(url)
          .then(function(response){
            return response.json();
          })
          .then(function(json){
            console.log(json);
            var val;
            if (type === 'singularDecimal'){
              val = json[a][b];
            }else if (type === 'dodo'){
              val = +json.data.resPricePerToToken - json.data.priceImpact;
            }else if (type === 'listDateDecimal'){
              var tgt = json[a];
              val = tgt.map((aTgt, index)=>{
                return {date:BigInt(Math.floor(aTgt[0]/1000)), value:aTgt[1]};
                // return {date:new Date(aTgt[0]), value:aTgt[1]};
              })

              if (val.length > 1){
                var firstTime = Number(val[0].date);
                var lastTime = Number(val[val.length - 1].date);
                if (lastTime - firstTime > 2 * 24 * 60 * 60){
                  let results = val.reduce((acc: any, cur: any) => {
                    let curDate = new Date(Number(cur.date) * 1000);
                    let curDateStr = curDate.getFullYear() + '-' + (curDate.getMonth() + 1) + '-' + curDate.getDate();
                    let existDateObj = acc.find(f => f.dStr === curDateStr);
                    if (existDateObj) {
                      let existDate = new Date(Number(existDateObj.date) * 1000);
                      if (curDate.getTime() > existDate.getTime()) {
                        acc = acc.filter(f => f.value !== existDateObj.value);
                        acc.push(Object.assign(cur, { dStr: curDateStr }));
                      }
                    } else {
                      acc.push(Object.assign(cur, { dStr: curDateStr }));
                    }

                    return acc;
                  }, []);
                  val = results
                }
              }
              
            }else if (type === 'singularTextFromObject'){
              val = json[a];
              val = val.split('infura.').join('');
            }
              setOtherInfo((otherInfo) => ({...otherInfo, [reference]:{loaded:1, v:val}}));
          })
          .catch(error => {
            var message = error.message;
            console.log(message);
            console.log(reference);
            console.log(url);
            setTimeout(function(){ 
              delete otherInfo[reference];
              setOtherInfo({...otherInfo});
            }, 1000);
          });

          otherInfo[reference] = {loading:1};
          setOtherInfo({...otherInfo});
      }
    }
    if (type === 'singularDecimal' || type === 'dodo'){
     return 0;      
    }else if (type === 'listDateDecimal'){
      return [];
    }else if (type === 'singularTextFromObject'){
      return '';
    }

}